'use client'

import { useI18n } from '@shared/config/i18n'
import { useEffect, useState } from 'react'
import QRCode from 'react-qr-code'

const PUBLIC_APP_DOWNLOAD_URL = 'https://podo.re-speak.com/open-in-app/home'

export const resolveAppDownloadUrl = (origin?: string) =>
  origin ? `${origin}/open-in-app/home` : PUBLIC_APP_DOWNLOAD_URL

export const JpAppDownloadPanel = ({ onNavigate }: { onNavigate?: () => void }) => {
  const { t } = useI18n()
  const [appDownloadUrl, setAppDownloadUrl] = useState(PUBLIC_APP_DOWNLOAD_URL)

  useEffect(() => {
    setAppDownloadUrl(resolveAppDownloadUrl(window.location.origin))
  }, [])

  return (
    <div className="w-full max-w-[305px] rounded-[12px] bg-white px-5 pb-4 pt-6 text-center shadow-[0_8px_32px_rgba(0,0,0,0.2)]">
      <div className="relative mx-auto h-[174px] w-[174px]">
        <QRCode
          value={appDownloadUrl}
          aria-label={t('lesson.jpTrial.completion.qrLabel')}
          data-testid="jp-app-download-qr"
          data-download-url={appDownloadUrl}
          className="absolute inset-[25px] h-[124px] w-[124px] bg-white"
        />
        <span
          aria-hidden="true"
          className="absolute left-0 top-0 h-7 w-7 rounded-tl-[6px] border-l-[4px] border-t-[4px] border-[#58C22D]"
        />
        <span
          aria-hidden="true"
          className="absolute right-0 top-0 h-7 w-7 rounded-tr-[6px] border-r-[4px] border-t-[4px] border-[#58C22D]"
        />
        <span
          aria-hidden="true"
          className="absolute bottom-0 left-0 h-7 w-7 rounded-bl-[6px] border-b-[4px] border-l-[4px] border-[#58C22D]"
        />
        <span
          aria-hidden="true"
          className="absolute bottom-0 right-0 h-7 w-7 rounded-br-[6px] border-b-[4px] border-r-[4px] border-[#58C22D]"
        />
      </div>

      <h2 className="mx-auto mt-12 max-w-[250px] whitespace-pre-line text-[16px] font-bold leading-6 text-[#1C1C1C]">
        {t('lesson.jpTrial.completion.downloadTitle')}
      </h2>
      <p className="mx-auto mt-4 max-w-[270px] text-[14px] leading-[22px] text-[#757575]">
        {t('lesson.jpTrial.completion.downloadGuide')}
      </p>
      {/* OS 판별용 User-Agent를 새 요청에서 읽어야 하므로 의도적으로 전체 페이지 이동을 사용한다. */}
      {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
      <a
        href="/qr/store"
        onClick={onNavigate}
        className="mt-6 flex h-[52px] w-full items-center justify-center rounded-[8px] border border-[#1C1C1C] bg-[#B5FD4C] text-[14px] font-bold text-[#1C1C1C] shadow-[0_4px_0_#1C1C1C]"
      >
        {t('lesson.jpTrial.completion.openApp')}
      </a>
    </div>
  )
}
